import React from 'react';
import PropTypes from 'prop-types';

class Video extends React.PureComponent {
  static propTypes = { refCallback: PropTypes.func };
  static defaultProps = { refCallback: el => {} };

  onRef = el => {
    this.props.refCallback(el);
  };

  render() {
    const { refCallback, ...otherProps } = this.props;

    const mergedProps = {
      muted: true,
      autoPlay: true,
      preload: true,
      playsInline: true,
      loop: true,
      ...otherProps,
      ref: this.onRef,
    };

    return <video {...mergedProps} />;
  }
}

export default Video;



// WEBPACK FOOTER //
// ./src/components/Video/Video.js